import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'disabled:cursor-not-allowed',
    container: 'flex items-center gap-2 has-[:disabled]:opacity-50'
  },
  variants: {},
  defaultVariants: {}
});
